<template>
  <main-template>
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex align-center">
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          <span class="text-h6 ml-2">Mensalidades</span>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <div v-if="carregando" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" />
          </div>

          <template v-else>
            <v-tabs v-model="abaSelecionada" grow>
              <v-tab>Em aberto</v-tab>
              <v-tab>Pagas</v-tab>
            </v-tabs>

            <v-tabs-items v-model="abaSelecionada">
              <!-- Aba Em aberto -->
              <v-tab-item class="pa-4">
                <div v-if="Object.keys(gruposEmAberto).length === 0" class="text-center py-8">
                  <v-icon size="48" color="success">mdi-check-circle-outline</v-icon>
                  <div class="text-body-2 grey--text mt-2">Nenhuma mensalidade em aberto.</div>
                </div>
                <div v-for="(itens, mes) in gruposEmAberto" :key="mes" class="mt-4">
                  <h3 class="text-subtitle-1 font-weight-bold px-1 mb-2">{{ mes }}</h3>
                  <v-card outlined>
                    <template v-for="(parcela, idx) in itens">
                      <v-list-item :key="parcela.id" class="py-2">
                        <v-list-item-content>
                          <v-list-item-title class="text-body-2 font-weight-medium">
                            {{ parcela.descricaoMensalidade }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="parcela.aluno" class="text-caption">
                            {{ parcela.aluno.nomecompleto }}
                          </v-list-item-subtitle>
                          <div v-if="parcela.referencia_3" class="text-caption grey--text mt-1">
                            Vencimento em
                            {{
                              parcela.referencia_3
                                | dateParse("YYYY-MM-DD")
                                | dateFormat("DD/MM/YYYY")
                            }}
                          </div>
                          <div class="d-flex flex-wrap gap-1 mt-1">
                            <v-chip v-if="parcela.estaAtrasada" x-small color="error" class="mr-1">
                              Atrasada
                            </v-chip>
                            <v-chip v-else x-small color="info" class="mr-1"> A vencer </v-chip>
                            <v-chip v-if="parcela.temDesconto" x-small color="success" class="mr-1">
                              Com desconto
                            </v-chip>
                          </div>
                          <div class="d-flex align-center mt-2">
                            <span
                              v-if="parcela.temDesconto"
                              class="text-caption grey--text mr-2"
                              style="text-decoration: line-through"
                            >
                              {{ parcela.valor | currency }}
                            </span>
                            <span class="text-body-2 font-weight-bold">
                              {{ parcela.valorEmAberto | currency }}
                            </span>
                            <v-spacer />
                            <router-link
                              :to="{
                                name: 'matriculas.mensalidades.detalhe',
                                params: {
                                  parcela_id: parcela.id,
                                  matricula_id: matriculaId,
                                },
                              }"
                              class="text-caption primary--text"
                            >
                              Ver detalhes &rarr;
                            </router-link>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="idx < itens.length - 1" :key="`div-${parcela.id}`" />
                    </template>
                  </v-card>
                </div>
              </v-tab-item>

              <!-- Aba Pagas -->
              <v-tab-item class="pa-4">
                <div v-if="Object.keys(gruposPagas).length === 0" class="text-center py-8">
                  <div class="text-body-2 grey--text">Nenhuma mensalidade paga encontrada.</div>
                </div>
                <div v-for="(itens, mes) in gruposPagas" :key="mes" class="mt-4">
                  <h3 class="text-subtitle-1 font-weight-bold px-1 mb-2">{{ mes }}</h3>
                  <v-card outlined>
                    <template v-for="(parcela, idx) in itens">
                      <v-list-item :key="parcela.id" class="py-2">
                        <v-list-item-content>
                          <v-list-item-title class="text-body-2 font-weight-medium">
                            {{ parcela.descricaoMensalidade }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="parcela.aluno" class="text-caption">
                            {{ parcela.aluno.nomecompleto }}
                          </v-list-item-subtitle>
                          <div class="d-flex align-center mt-2">
                            <v-chip x-small color="success" class="mr-2">Paga</v-chip>
                            <span class="text-body-2 font-weight-bold">
                              {{ parcela.valorPago | currency }}
                            </span>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="idx < itens.length - 1" :key="`div-${parcela.id}`" />
                    </template>
                  </v-card>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import groupBy from "lodash/groupBy";
import Parcela from "@/Models/Parcela";

export default {
  name: "MensalidadesLista",

  computed: {
    ...mapGetters("Mensalidades", ["matriculaSelecionada"]),

    matriculaId() {
      return this.$route.params.matricula_id;
    },

    parcelas() {
      if (!this.matriculaSelecionada?.parcelas) return [];
      const aluno = this.matriculaSelecionada.aluno;
      const turma = this.matriculaSelecionada.turma;
      return this.matriculaSelecionada.parcelas.map((p) => new Parcela({ ...p, aluno, turma }));
    },

    gruposEmAberto() {
      const emAberto = this.parcelas.filter((p) => p.estaEmAberto);
      return groupBy(emAberto, (p) => p.mesAnoReferencia);
    },

    gruposPagas() {
      const pagas = this.parcelas.filter((p) => p.valorpago);
      return groupBy(pagas, (p) => p.mesAnoReferencia);
    },
  },

  data() {
    return {
      carregando: false,
      abaSelecionada: 0,
    };
  },

  async mounted() {
    await this.carregarDados();
  },

  methods: {
    async carregarDados() {
      this.carregando = true;
      try {
        const matricula = await this.$services.matriculasService.pegarMatricula(this.matriculaId);
        const matriculaDetalhada = await this.$services.matriculasService.getDetails(matricula.id);
        this.$store.commit("Mensalidades/setMatriculaSelecionada", matriculaDetalhada);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>
